import { RouteObject } from 'react-router-dom'
import { ERoutes } from 'common/entities/routes'
import accountant from './accountant'
import ContactsManager from './contactsManager'
import Contract from './contract'
import IdentityValidate from './identityValidate'
import idMagaluMigration from './idMagaluMigration'
import MyAccount from './myaccount'
import PageComponents from './pageComponents'
import RegulatoryData from './regulatoryData'

const protectedRoutes: RouteObject[] = [
  ...accountant,
  ...PageComponents,
  ...ContactsManager,
  ...MyAccount,
  ...Contract,
  ...RegulatoryData,
  ...IdentityValidate,
]

const publicRoutes: RouteObject[] = [
  {
    path: ERoutes.ID_MAGALU_PRELOGIN,
    async lazy() {
      const { default: Component } = await import('containers/LandingPageEmail/LandingPageEmail')
      return { Component }
    },
  },
  {
    path: ERoutes.ONBOARDING,
    async lazy() {
      const { default: Component } = await import('pages/Onboarding')
      return { Component }
    },
  },
  {
    path: ERoutes.ID_MAGALU_LOGIN,
    async lazy() {
      const { default: Component } = await import('containers/IdMagalu/Login/NavigateToLogin')
      return { Component }
    },
  },
  ...idMagaluMigration,
]

export default {
  protectedRoutes,
  publicRoutes,
}
